export const INTERVIEW_LIST_PAGE_TEXT = {
  INTERVIEW_LIST: 'Interview List',
  APPLICATION_NO: 'Application No',
  NAME: 'Name',
  ENTRY_YEAR: 'Entry Year',
  DEPARTMENT: 'Department',
  PROGRAMME: 'Programme',
  CHIEF_SUPERVISOR: 'Chief Supervisor',
  STATUS: 'Status',
  ACTION: 'Action',
  VIEW_APPLICATION_DETAIL: 'View Application Detail',
  DOWNLOAD_APPLICATION_PROFILE: 'Download Profile',
  INVALID_APPLICATIONID: 'Invalid Application Id',
  DUAL: 'Dual',
  JOint_SUPERVISION: 'Joint Supervision',
  NA: 'N/A',
  STUDY_MODE: 'Study Mode',
  FUNDING_SCHEME: 'Funding Scheme',
  RESEARCH_AREA: 'Research Area',
  APPLICANT_PARTICULARS: 'Applicant Particulars',
  INTERVIEW_REPORT: 'Interview Report',
  SUBMIT: 'Submit',
  CANCEL: 'Cancel',
  BACK: 'Back',
  SUBMIT_CONFIRM: {
    ARE_YOU_SURE_YOU_WANT_TO_SUBMIT_THE_INTERVIEW_REPORT:
      'Are you sure you want to submit this interview report?',
    ONCE_SUBMITTED_THE_INTERVIEW_REPORT_WILL_BE_REVIEWED_BY_DORPGS_YOU_CANNOT_REVISE_THIS_INTERVIEW_REPORT:
      'Once submitted, the interview report will be reviewed by DoRPgS. You cannot revise this interview report.',
  },
  ALERT: {
    PLEASE_COMPLETE_ALL_QUESTIONS_IN_INTERVIEW_REPORT:
      'Please complete the Interview Assessment and all questions in Interview Report.',
    SUBMIT_INTERVIEW_REPORT_SUCCESSFULLY:
      'Submit interview report successfully.',
  },
};
